<ral-card (click)="open(to['open'])">
  <div
    class="e-card-header"
    style="width: 100%"
    *ngIf="to.label || to.description"
  >
    <div
      *ngIf="to['label'] && to['hideLabel'] !== true"
      class="ui-widget label-wrapper"
    >
      <div class="p-grid p-nogutter p-justify-between">
        <div class="p-col-fixed">
          {{ to.label }}
          <span *ngIf="to['required'] && to['hideRequiredMarker'] !== true"
            >*</span
          >
        </div>
        <div
          class="p-col-fixed"
          *ngIf="!(to.disabled || formState['readonly'])"
          style="margin-top: -6px; margin-right: -6px"
        >
          <div class="p4-grid p4-grid--with-bottom">
            <div class="p-col-fixed" *ngIf="to['actionText']">
              <button
                type="button"
                class="e-btn e-lib e-small e-primary"
                (click)="action()"
              >
                <span>
                  {{ to['actionText'] }}
                </span>
              </button>
            </div>
            <!-- <div class="p-col-fixed">
              <button
                type="button"
                class="e-btn e-lib e-small e-primary e-decent"
                (click)="toggle()"
              >
                <i *ngIf="!to['open']" class="fal fa-fw fa-edit"></i>
                <i *ngIf="to['open']" class="fal fa-fw fa-compress-alt"></i>
              </button>
            </div> -->
          </div>
        </div>
      </div>

      <p *ngIf="to.description" class="description">{{ to.description }}</p>
    </div>
  </div>
  <div class="e-card-content">
    <ng-container #fieldComponent></ng-container>

    <!-- class="ui-message ui-widget ui-corner-all ui-message-error ui-messages-error" -->
    <div *ngIf="showError">
      <formly-validation-message
        class="p-error"
        [field]="field"
      ></formly-validation-message>
    </div>

    <p
      *ngIf="
        !to['open'] &&
        !field.formControl?.valid &&
        !to.disabled &&
        !formState['readonly'] &&
        !to['readonly'] &&
        (field.formControl?.dirty || field.formControl?.touched)
      "
      class="errorWrapperMessage"
      style="cursor: pointer"
    >
      {{ 'TPA.SectionContainsErrors' | transloco }}
    </p>
  </div>
</ral-card>

<!-- <div class="ui-messages-error" *ngIf="showError">
  <formly-validation-message [field]="field"></formly-validation-message>
</div> -->
